var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalAssets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67495",
    "data-name": "Group 67495",
    transform: "translate(-332 -756)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22412",
    "data-name": "Rectangle 22412",
    width: 72,
    height: 72,
    transform: "translate(332 756)",
    fill: "#fff5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-usd-circle",
    transform: "translate(348 772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67455",
    "data-name": "Group 67455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67454",
    "data-name": "Group 67454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80507",
    "data-name": "Path 80507",
    d: "M20,0A20,20,0,1,0,40,20,20.022,20.022,0,0,0,20,0Zm0,36.667A16.667,16.667,0,1,1,36.667,20,16.686,16.686,0,0,1,20,36.667Zm6.667-13.333a5.006,5.006,0,0,1-5,5V30a1.667,1.667,0,1,1-3.333,0V28.333h-.447a5.017,5.017,0,0,1-4.33-2.5,1.667,1.667,0,1,1,2.883-1.67A1.672,1.672,0,0,0,17.885,25h3.78a1.667,1.667,0,0,0,1.667-1.667,1.28,1.28,0,0,0-1.073-1.267l-5.068-.845a4.6,4.6,0,0,1-3.858-4.555,5.006,5.006,0,0,1,5-5V10a1.667,1.667,0,1,1,3.333,0v1.667h.447a5.019,5.019,0,0,1,4.33,2.5,1.667,1.667,0,1,1-2.883,1.668A1.673,1.673,0,0,0,22.113,15h-3.78a1.668,1.668,0,0,0-1.667,1.667,1.28,1.28,0,0,0,1.073,1.267l5.068.845a4.6,4.6,0,0,1,3.858,4.555Z",
    fill: "#ff8383"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAssets);
export default __webpack_public_path__ + "static/media/total-assets.ae26d8173cfd070febf8250f4e9233be.svg";
export { ForwardRef as ReactComponent };